import Waystation, { WaystationNoise } from './Waystation';
import waypoints from './questionMarks.waypoints.json';
import noise from './questionMarks.noise.json';

export default function QuestionMarks() {
  return (
    <>
      { waypoints.map(props => <Waystation {...props} />) }
      { noise.map(props => <WaystationNoise {...props} />) }
    </>
  );
};